<template>
  <el-dialog
    title="一键清空全部物品"
    :visible.sync="show"
    width="580px"
    :close-on-click-modal="false"
    :close-on-press-escape="!saving"
    :show-close="!saving">
    <el-alert
      title="严重警告：此操作将永久删除库存中的全部物品资料，删除后无法恢复！"
      type="error"
      :closable="false"
      show-icon />

    <div class="danger-details">
      <p>执行后，物品名称、分类、单位、价格、库存数量等资料都会被删除。</p>
      <p>系统会在删除前自动生成完整备份；备份失败时不会删除任何物品。</p>
      <p>正在审批过程中的物品不会删除，系统会自动跳过并在完成后提示数量。</p>
    </div>

    <div class="confirm-label">
      如确认继续，请在下方完整输入：<strong>确认删除</strong>
    </div>
    <el-input
      v-model="confirmText"
      :disabled="saving"
      placeholder="请输入“确认删除”"
      autocomplete="off"
      @keyup.enter.native="submit" />
    <div v-if="confirmText && !confirmed" class="confirm-error">
      输入内容不正确，必须完整输入“确认删除”四个字。
    </div>

    <div slot="footer">
      <el-button :disabled="saving" @click="show = false">取消</el-button>
      <el-button type="danger" :disabled="!confirmed" :loading="saving" @click="submit">
        永久删除全部物品
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      saving: false,
      confirmText: ""
    };
  },
  computed: {
    confirmed() {
      return this.confirmText === "确认删除";
    }
  },
  methods: {
    init() {
      this.confirmText = "";
      this.saving = false;
      this.show = true;
    },
    submit() {
      if (!this.confirmed || this.saving) return;

      this.saving = true;
      this.whale.remote.getResult({
        url: "/api/School/MAT/StockApi/ClearAllData",
        data: { CONFIRM_TEXT: this.confirmText },
        completed: response => {
          const result = response.DATA || {};
          const cleared = result.CLEARED_COUNT || 0;
          const skipped = result.SKIPPED_COUNT || 0;
          const backupGuid = result.BACKUP_GUID || "";
          this.show = false;
          if (skipped > 0) {
            this.$message.warning(`已备份并删除${cleared}个物品，另有${skipped}个物品正在审批中，未予删除。备份批次：${backupGuid}`);
          } else {
            this.$message.success(`一键清空完成，已备份并删除${cleared}个物品。备份批次：${backupGuid}`);
          }
          this.$emit("on-cleared");
        },
        finally: () => { this.saving = false; }
      });
    }
  }
};
</script>

<style scoped>
.danger-details {
  margin: 18px 0;
  padding: 12px 16px;
  color: #606266;
  line-height: 1.7;
  background: #fdf6ec;
  border: 1px solid #faecd8;
  border-radius: 4px;
}
.danger-details p {
  margin: 0;
}
.danger-details p + p {
  margin-top: 6px;
}
.confirm-label {
  margin-bottom: 10px;
  color: #303133;
}
.confirm-label strong {
  color: #f56c6c;
}
.confirm-error {
  margin-top: 7px;
  color: #f56c6c;
  font-size: 12px;
}
</style>
